import { render, staticRenderFns } from "./UserAdminManageUserPermissions.vue?vue&type=template&id=5d472ae0&scoped=true"
import script from "./UserAdminManageUserPermissions.vue?vue&type=script&lang=js"
export * from "./UserAdminManageUserPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserAdminManageUserPermissions.vue?vue&type=style&index=0&id=5d472ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d472ae0",
  null
  
)

export default component.exports